import { formatNumber } from "@/i18n";

const UNITS = ["byte", "kilobyte", "megabyte", "gigabyte"] as const;

/**
 * A byte count as the user's language writes it ("2.4 MB", "2,4 MB"), in
 * steps of 1024 like the upload limits; "" for anything but a count.
 */
export function fileSizeLabel(bytes: unknown): string {
  if (typeof bytes !== "number" || !Number.isFinite(bytes) || bytes < 0) {
    return "";
  }
  let value = bytes;
  let unit = 0;
  // 1023.6 kB would round to "1,024 kB": it is 1 MB.
  while (value >= 1023.5 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return formatNumber(value, {
    style: "unit",
    unit: UNITS[unit],
    unitDisplay: unit === 0 ? "long" : "short",
    maximumFractionDigits: unit === 0 || value >= 10 ? 0 : 1,
  });
}
